import React,{useEffect,useState} from 'react'
import {Routes, Route,useNavigate,useLocation, Link} from 'react-router-dom';
import Logo from '../../assets/images/logo.png'
import routes from '../../routes';
import Header from '../../components/common/Header';
import { getUserProfileDetail,getCountryCode, getStudentFee } from '../../actions/StudentAction';
import { StateUseContext } from '../../context/UserDetailContext';
import swal from 'sweetalert';

const Student = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {userDetail,setUserDetail,setCountryCode,setFeeDetail,setFeeLoader,PageLoader,setPageLoader} = StateUseContext();
    const {country_id} = userDetail !==undefined && userDetail
    const userFind = sessionStorage.getItem("token");

   
    useEffect(() => {
        if(!userFind){
            navigate('/login')
        }

        const handleContextMenu = (e) => {
            e.preventDefault();
          };
      
          document.addEventListener('contextmenu', handleContextMenu);
        
        const userProfileDetail = async() => {

            try {
                await getUserProfileDetail().then((res) => {
                    if(res.status){
                        setUserDetail(res !==undefined && res.data)
                        setPageLoader(false)
                    }
                    else{
                        swal('Session is Expired! Please login again','','error')
                        sessionStorage.clear();
                        navigate('/login')
                    }
                });
            } catch (error) {
                console.log('dashboard...',error)
            }
        }

        if(userFind){
            userProfileDetail()

        }
        if(userDetail ==[] || !userDetail){
            navigate('/login')
        }

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
          };
   
    },[location.pathname,userFind])


    useEffect(() => {
        const countryCode = async() => {
            try {
                await getCountryCode(country_id).then((res) => {
                    if(res.status){
                        setCountryCode(res?.data)
                    }
                })
            } catch (error) {
                console.log('country code error...',error)
            }
        }
        const studentFeeData = async() => {
            try {
                await getStudentFee(userDetail?.id).then((res) => {
                    if(res.status){
                        setFeeLoader(false)
                        setFeeDetail(res.data)
                    }
                    else{
                        setFeeLoader(false)
                    } 
                })
            } catch (error) {
                console.log('fee error',error)
            }
        }

        if(userDetail !==undefined && userFind){
            studentFeeData()
            countryCode()
        }

        if(userDetail ==[]){
            navigate('/login')
        }

   
    },[userDetail.country_id,userDetail.id,userDetail.course_name,userDetail.center_name,location.pathname])


    const getRoutes = (routes) => {
        return routes.map((prop,key) => {
            if(prop.layout ==='/student'){
                return(
                    <>
                    <Route  path={prop.path} element={prop.component}  key={key}/>
                    {/* <Route  path='*' key={12} element={()=>{
                       
                        return (
                        <div className='page_not_found'>
                        <h1 className='text-center'>404</h1>
                        <p>Page not found</p>
                        <Link to={'dashboard'} className='btn btn-primary'>Return to Dashboard</Link>
                        </div>
                        )
                    }}/> */}
                      </>
                )
            }
            else{
                return null;
            }
        })
    }
  return (
    PageLoader ? <div className="pageLoader">
        <img src={Logo} alt="Logo" style={{height:'60px',display:'block'}} />
       {/* <p>Loading...</p>  */}
        </div> :
    <>
    <Header/>
    <div>
        <Routes>
            {getRoutes(routes)}
        </Routes>
        
    </div>
    </>

  )
}

export default Student